import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export const queryGovReportingConfigAtom = createQueryAtomFactory(
  'settings.govReportingConfig',
  ({ id }: { id: string }) => ({
    governmentReportingConfiguration: {
      __args: {
        id,
      },
      id: true,
      serviceType: true,
      name: true,
      uploadType: true,
      recyclerId: true,
      toEmailAddress: true,
      uploadTimezone: true,
      daysOfWeek: true,
      processBatchesAsUnit: true,
      isActive: true,
      fields: true,
      timestamps: {
        createdAt: true,
        updatedAt: true,
      },
    },
  }),
  {
    select: (data) => {
      const config = data?.governmentReportingConfiguration;
      if (!config) return undefined;

      return {
        id: config.id,
        serviceType: config.serviceType,
        name: config.name,
        uploadType: config.uploadType,
        recyclerId: config.recyclerId,
        toEmailAddress: config.toEmailAddress,
        uploadTimezone: config.uploadTimezone,
        daysOfWeek: config.daysOfWeek,
        processBatchesAsUnit: config.processBatchesAsUnit,
        isActive: config.isActive,
        fields: config.fields,
        createdAt: config.timestamps.createdAt,
        updatedAt: config.timestamps.updatedAt,
      };
    },
  },
);
